import { OktaAuth } from '@okta/okta-auth-js';

// Okta configuration
const oktaDomain = 'https://safeguard.okta.com';
const clientId = '0oasubmexeMBfGggu697';
const redirectUri = window.location.origin;

// Initialize Okta Auth
const oktaAuth = new OktaAuth({
    issuer: `${oktaDomain}/oauth2/ausuf783nZ9zLSxZt696`,
    clientId: clientId,
    redirectUri: redirectUri,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    tokenManager: {
        autoRenew: true,
        secure: true
    }
});

// Handle login
const login = () => {
    // Check if user is already authenticated
    const token = localStorage.getItem('okta-token');
    if (token) {
        window.location.href = redirectUri;
        return;
    }

    try {
        // Start the login flow with explicit configuration
        oktaAuth.token.getWithRedirect({
            responseType: ['code'],
            scopes: ['openid', 'profile', 'email'],
            state: Math.random().toString(36).substring(2),
            nonce: Math.random().toString(36).substring(2)
        });
    } catch (error) {
        console.error('Error during authentication:', error);
        return { error: 'Authentication failed. Please try again.' };
    }
};

// Handle the callback after redirect
const handleCallback = async () => {
    try {
        const tokens = await oktaAuth.token.parseFromUrl();
        if (tokens && tokens.tokens) {
            // Store the tokens
            localStorage.setItem('okta-token', tokens.tokens.accessToken.accessToken);
            localStorage.setItem('okta-id-token', tokens.tokens.idToken.idToken);
            
            return { success: true };
        }
        return { error: 'Invalid token response' };
    } catch (error) {
        console.error('Error handling callback:', error);
        return { error: 'Error processing authentication. Please try again.' };
    }
};

// Handle logout
const logout = () => {
    try {
        console.log('Logging out user...');
        
        // Get the ID token from localStorage
        const idToken = localStorage.getItem('okta-id-token');
        
        if (idToken) {
            console.log('ID token found, performing Okta logout');
            // Clear local storage
            localStorage.removeItem('okta-token');
            localStorage.removeItem('okta-id-token');
            
            // Perform Okta logout with redirect
            window.location.href = `${oktaDomain}/oauth2/ausuf783nZ9zLSxZt696/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${window.location.origin}/login`;
        } else {
            console.log('No ID token found, performing basic logout');
            // Fallback to regular logout if no ID token
            localStorage.removeItem('okta-token');
            localStorage.removeItem('okta-id-token');
            window.location.href = `${oktaDomain}/login/signout?fromURI=${encodeURIComponent(window.location.origin + '/login')}`;
        }
    } catch (error) {
        console.error('Logout error:', error);
        // Fallback to regular logout on error
        localStorage.removeItem('okta-token');
        localStorage.removeItem('okta-id-token');
        window.location.href = '/login';
    }
};

// Check if user is authenticated
const isAuthenticated = () => {
    const token = localStorage.getItem('okta-token');
    return !!token;
};

// Get the authentication token
const getToken = () => {
    return localStorage.getItem('okta-token');
};

export default {
    login,
    handleCallback,
    logout,
    isAuthenticated,
    getToken
}; 
